class StoresWrapper extends HTMLElement {
  /** @type {HTMLIFrameElement} */
  map;
  /** @type {HTMLDivElement} */
  blocksContainer;

  constructor() {
    super();

    window.addEventListener("DOMContentLoaded", () =>
      this.onDOMContentLoaded()
    );
  }

  onDOMContentLoaded() {
    this.map = this.querySelector("#store-locator-map");
    this.blocksContainer = this.querySelector(".blocks-container");

    if (this.blocksContainer.firstElementChild) {
      this.map.setAttribute(
        "src",
        this.blocksContainer.firstElementChild.dataset.embed
      );
    }

    this.handleBlocks();
  }

  handleBlocks() {
    const blocks = this.blocksContainer.querySelectorAll("div");

    if (blocks.length < 1) return;

    const handleClickedBlock = () => {
      blocks.forEach((block) => {
        if (block.dataset.embed === this.map.src) {
          block.style.border = "3px solid black";
        } else {
          block.style.border = "1px solid #ccc";
        }
      });
    };

    blocks.forEach((block) => {
      block.addEventListener("click", (e) => {
        this.map.setAttribute("src", e.currentTarget.dataset.embed);
        window.scroll({
          behavior: "smooth",
          left: 0,
          top: 0,
        });

        handleClickedBlock();
      });
    });

    handleClickedBlock();
  }
}

customElements.define("store-wrapper", StoresWrapper);
